import { render, staticRenderFns } from "./WhitelistManagement.vue?vue&type=template&id=15168a01&scoped=true&"
import script from "./WhitelistManagement.vue?vue&type=script&lang=js&"
export * from "./WhitelistManagement.vue?vue&type=script&lang=js&"
import style0 from "./WhitelistManagement.vue?vue&type=style&index=0&id=15168a01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15168a01",
  null
  
)

export default component.exports